import { ModalLoading } from 'components/ModalLoading';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { UerExportWorkOrderChangeAsExcelQuery } from 'gql/graphql';
import { downloadURI } from 'utils/downloadDataURI';
import type { TActionCommonInterface } from 'utils/types';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { uerExportWorkOrderChangeAsExcelGql } from './exportWorkOrderChangeQueries';

interface IExportWorkOrderChange {
    workOrderChangeId: number;
    onClose: () => void;
}

const requestId = 'exportWorkOrderChange';

export const ExportWorkOrderChange = (props: IExportWorkOrderChange) => {
    const { onClose, workOrderChangeId } = props;

    const dispatch = useDispatch();

    const [resetData] = useResetStoreData({ requestId });

    const variables = useMemo(
        () => ({
            workOrderChangeId,
        }),
        [workOrderChangeId],
    );

    const onSuccess = useCallback(
        (res: TActionCommonInterface<UerExportWorkOrderChangeAsExcelQuery>) => {
            const { name, dataUrl } = res?.payload?.uerExportWorkOrderChangeAsExcel?.data ?? {};

            if (dataUrl && name) {
                downloadURI(dataUrl, name);
            }

            onClose();
            resetData(undefined);
        },
        [onClose, resetData],
    );

    const [, , , , , abortRequest] = useRequest({
        requestId,
        query: uerExportWorkOrderChangeAsExcelGql,
        withEffect: !!workOrderChangeId,
        variables,
        dependenciesUpdater: onSuccess,
    });

    const onLocalClose = useCallback(() => {
        dispatch(abortRequest());
        onClose();
    }, [abortRequest, dispatch, onClose]);

    return <ModalLoading title="Выгрузка Изм к НЗ" onClose={onLocalClose} />;
};

ExportWorkOrderChange.displayName = 'ExportWorkOrderChange';
